import * as Yup from "yup";
import RouteModel from "../../models/masters/route-model";
import { API_END_POINT } from "../../constants";
import { InputField } from "../../components/form/input.field.component";
import {
  FormikModelDialog,
  SubmitStatus,
} from "../../core/formik-model-dialog.component";
import {
  CheckboxField,
  CheckBoxStyle,
} from "../../core/checkbox-field.component";
import { SelectField } from "../../core/select-field.component";
import { useEffect, useState } from "react";
import { useGetRouteCity } from "../../apiclient/master/useGetRouteCityApi";
import { useGetUnions } from "../../apiclient/master/useGetUnionsApi";
import { useGetRoute } from "../../apiclient/master/useGetRouteApi";

interface RouteEditProps {
  data: RouteModel;
  isViewMode?: boolean;
  onClose?: (status: SubmitStatus, data: any) => any;
}

const RouteEntry: React.FC<RouteEditProps> = ({ ...props }) => {
  let { data, onClose, isViewMode } = props;
  const title = data?.routeId > 0 ? "Edit Route" : "Add Route";

  let initialValue: RouteModel = {
    routeId: data?.routeId || 0,
    name: data?.name,
    morningOrderExpiryTime: data?.morningOrderExpiryTime,
    eveningOrderExpiryTime: data?.eveningOrderExpiryTime,
    morningDepartureTime: data?.morningDepartureTime,
    eveningDepartureTime: data?.eveningDepartureTime,
    routeCityId: data?.routeCityId || 0,
    routeCityName: data?.routeCityName,
    unionId: data?.unionId || 0,
    unionName: data?.unionName,
    isLeak: !!data?.isLeak,
    isActive: data?.routeId > 0 ? data.isActive : true,
  };
  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required("Required")
      .test("check-duplicate-name", "Route name already exists", (value) => {
        if (!value) return false;

        return (
          !existingName.some(
            (existing) =>
              existing &&
              typeof existing === "string" &&
              existing.toLowerCase() === value.toLowerCase()
          ) ||
          (data?.name && value === data.name)
        );
      }),
  });

  const [existingName, setExistingName] = useState<string[]>([]); // state to hold existing zone names
  const { data: fetchedRoute } = useGetRoute();

  const [routeCityData, setRouteCityData] = useState<
    { value: string; label: string }[]
  >([]);
  const [unionData, setUnionData] = useState<
    { value: string; label: string }[]
  >([]);

  const { data: fetchedRouteCity } = useGetRouteCity();
  const { data: fetchedUnions } = useGetUnions();

  useEffect(() => {
    if (fetchedRoute) {
      setExistingName(fetchedRoute.map((zone: any) => zone.name ?? "")); // Avoid nulls
    }

    if (fetchedRouteCity) {
      const mappedRouteCity = fetchedRouteCity.map((routecity: any) => ({
        value: routecity.routeCityId.toString(),
        label: routecity.name,
      }));
      setRouteCityData(mappedRouteCity);
    }
  }, [fetchedRouteCity, fetchedRoute]);

  useEffect(() => {
    if (fetchedUnions) {
      const mappedUnion = fetchedUnions.map((union: any) => ({
        value: union.unionId.toString(),
        label: union.name,
      }));
      setUnionData(mappedUnion);
    }
  }, [fetchedUnions]);

  return (
    <>
      <FormikModelDialog
        width="50%"
        title={title}
        initialData={initialValue}
        validationSchema={validationSchema}
        show={!!data}
        onClose={onClose}
        endpoint={API_END_POINT.MASTER}
        postRoute="Route/SaveRoute"
        showAddAnother={true}
        isViewOnly={isViewMode}
        isUpDateEntityDetails={data?.routeId > 0 ? true : false}
      >
        <div>
          <div className="row">
            <div className="col-3">
              <InputField maxLength={100} label="Route *" name="name" />
            </div>

            <div className="col-4">
              <SelectField
                label="Route City"
                name="routeCityId"
                options={routeCityData}
                unSelectValue={0}
              />
            </div>

            <div className="col-4">
              <SelectField
                label="Union"
                name="unionId"
                options={unionData}
                unSelectValue={0}
              />
            </div>

            <div className="col-4">
              <InputField
                type="time"
                label="Morning Order Expiry Time"
                name="morningOrderExpiryTime"
              />
            </div>

            <div className="col-4">
              <InputField
                type="time"
                label="Evening Order Expiry Time"
                name="eveningOrderExpiryTime"
              />
            </div>

            <div className="col-4">
              <InputField
                type="time"
                label="Morning Departure time"
                name="morningDepartureTime"
              />
            </div>

            <div className="col-4">
              <InputField
                type="time"
                label="Evening Departure time"
                name="eveningDepartureTime"
              />
            </div>

            <div className="col-4">
              <CheckboxField
                isChecked={initialValue.isLeak}
                label="Is Leak?"
                name="isLeak"
                checkstyle={CheckBoxStyle.Normal}
              />
            </div>

            <div className="col-4">
              <CheckboxField
                isChecked={initialValue.isActive}
                label="Is Active?"
                name="isActive"
                checkstyle={CheckBoxStyle.Normal}
              />
            </div>
          </div>
        </div>
      </FormikModelDialog>
    </>
  );
};

export default RouteEntry;
